import PropTypes from 'prop-types';

/**
 * PropTypes for the FooterList component.
 */
export const footerListPropTypes = {
  /**
   * Object containing actions for the FooterList component.
   * It includes a router object with a set function for navigation.
   *
   * @type {Object}
   * @property {Object} actions.router - The router object used for navigation.
   * @property {function} actions.router.set - Function to set the current route. (Required)
   */
  actions: PropTypes.shape({
    router: PropTypes.shape({
      set: PropTypes.func.isRequired,
    }).isRequired,
  }).isRequired,

  /**
   * Array of section objects to be displayed in the footer.
   * Each section contains a title and a list of items with labels and links.
   *
   * @type {Array<{title: string, items: Array<{label: string, link: string}>}>}
   * @property {string} title - The title of the section. (Required)
   * @property {Array<{label: string, link: string}>} items - List of items in the section. Each item has a label and a link. (Required)
   */
  sections: PropTypes.arrayOf(
    PropTypes.shape({
      title: PropTypes.string.isRequired,
      items: PropTypes.arrayOf(
        PropTypes.shape({
          label: PropTypes.string.isRequired,
          link: PropTypes.string.isRequired,
        }),
      ).isRequired,
    }),
  ).isRequired,

  /**
   * Background color for the FooterList component.
   * This should be a valid CSS color string.
   *
   * @type {string}
   */
  backgroundColor: PropTypes.string,
};

/**
 * Default props for the FooterList component.
 */
export const footerListDefaultProps = {
  backgroundColor: '#0D3B66',
};

export default footerListPropTypes;
